import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { MDBContainer } from 'mdbreact';
import '../Help and Support/Faq.css'
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
}));

export default function PassportInformation() {
    const { t, i18n } = useTranslation();
    const classes = useStyles();

    return (
        <MDBContainer className="container" >
            <div class="row passportaccordion" >
                <div class="col-lg-12 mr-5">
                <div class="u-center-text u-margin-bottom-big mt-5">
                    {/* <h2 class="heading-secondary">  <Trans>howToApply.howtoApply</Trans></h2> */}
                </div>

                    <div className={classes.root} class='faq-accordion'>
                        <Accordion className='accordion-item'>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography className='accordion-title'>
                                <Trans>howToApply.newPassport</Trans>
                            </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    <p class='font-weight-bold'>
                                  <Trans>requirments.new.title</Trans>  
                                    </p>

                                    <br></br>
                                    <ol>
                                        <li><Trans>requirments.common.itemOne</Trans></li>
                                        <ul class='my-1'>
                                            <li><Trans>requirments.new.itemOneL1</Trans> </li>

                                        </ul>

                                        {/* <li><Trans>requirments.common.itemTwo</Trans></li>
                                        <ul class='my-1'>
                                            <li><Trans>requirments.common.itemTwoL1</Trans></li>
                                            <li><Trans>requirments.common.itemTwoL2</Trans></li>
                                            <li><Trans>requirments.common.itemTwoL3</Trans></li>
                                            <li><Trans>requirments.common.itemTwoL4</Trans></li>
                                            <li><Trans>requirments.common.itemTwoL5</Trans></li>
                                            <li><Trans>requirments.common.itemTwoL6</Trans></li>
                                            <li><Trans>requirments.common.itemTwoL7</Trans></li>
                                        </ul> */}
                                        <li><Trans>requirments.common.itemThree</Trans></li>
                                        <table class="table w-75 my-1">
                                            <thead class="thead-lightt">
                                                <tr>

                                                    <th scope="col"><Trans>requirments.common.passportType</Trans></th>
                                                    <th scope="col"><Trans>requirments.common.price</Trans></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><Trans>New</Trans></td>
                                                    <td>5000 </td>
                                                </tr>
                                                <tr>
                                                </tr>
                                                {/* <tr>
                                                    <td colspan="2" class='font-weight-bold'><Trans>requirments.common.forUrgent</Trans></td>

                                                </tr> */}
                                            </tbody>
                                        </table>
                                        <li><Trans>requirments.common.itemFour</Trans></li>
                                        <li><Trans>requirments.common.itemFive</Trans></li>
                                        <li><Trans>requirments.common.itemSix</Trans></li>
                                        <li><Trans>requirments.common.itemSeven</Trans></li>
                                        <ul class='my-1'>
                                            <li><Trans>requirments.common.itemSeven1</Trans></li>
                                            <li><Trans>requirments.common.itemSeven2</Trans></li>
                                            <li><Trans>requirments.common.itemSeven3</Trans></li>
                                        </ul>
                                    </ol>

                                </Typography>
                            </AccordionDetails>
                            <div class="col-12 medium text-center my-3"><Link to="/request-appointment" class="btn btnBlu"><Trans>requirments.common.applynow</Trans></Link></div>
                        </Accordion>
                        <Accordion className='accordion-item'>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography className='accordion-title'>
                                <Trans>howToApply.expiredPassport</Trans>
      </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    <p class='font-weight-bold'>
                                    <Trans>requirments.expiredPassport.title</Trans>  
                                    </p>

                                    <br></br>
                                    <ol>
                                        <li>  <Trans>requirments.common.itemOne</Trans> </li>
                                        <ul class='my-1'>
                                            <li> <Trans>requirments.expiredPassport.itemOneL1</Trans></li>

                                        </ul>
        
                                        <li><Trans>Check the service fee for renewing an expired Passport</Trans></li>
                                        <table class="table w-75 my-1">
                                            <thead class="thead-lightt">
                                                <tr>

                                                    <th scope="col"><Trans>requirments.common.passportType</Trans></th>
                                                    <th scope="col"><Trans>requirments.common.price</Trans></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><Trans>Expired</Trans></td>
                                                    <td>5000 Birr</td>
                                                </tr>
                                                {/* <tr>
                                                    <td colspan="2" class='font-weight-bold'><Trans>requirments.common.forUrgent</Trans></td>

                                                </tr> */}
                                            </tbody>
                                        </table>
                                        <li><Trans>requirments.common.itemFour</Trans></li>
                                        <li><Trans>requirments.common.itemFive</Trans></li>
                                        <li><Trans>requirments.common.itemSix</Trans></li>
                                        <li><Trans>requirments.common.itemSeven</Trans></li>
                                        <ul class='my-1'>
                                            <li><Trans>requirments.common.itemSeven1</Trans></li>
                                            <li><Trans>requirments.common.itemSeven2</Trans></li>
                                            <li><Trans>requirments.common.itemSeven3</Trans></li>
                                        </ul>
                                    </ol>

                                </Typography>


                            </AccordionDetails>
                            <div class="col-12 medium text-center my-3"><Link to="/request-appointment" class="btn btnBlu"><Trans>requirments.common.applynow</Trans></Link></div>
                        </Accordion>
                        <Accordion className='accordion-item'>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3a-content"
                                id="panel3a-header"
                            >
                                <Typography className='accordion-title'>
                                <Trans>howToApply.passportRunout</Trans>
      </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    <p class='font-weight-bold'>
                                    <Trans>For applicants of passport pages to run out must fulfill the following requirements.</Trans>  

                                    </p>

                                    <br></br>
                                    <ol>
                                        <li><Trans>requirments.common.itemOne</Trans>  </li>
                                        <ul class='my-1'>
                                            <li> <Trans>requirments.passportRunout.itemOneL1</Trans>   </li>

                                        </ul>

                                        <li><Trans>    Check the service fee for the page run out Passport </Trans></li>
                                        <table class="table w-75 my-1">
                                            <thead class="thead-lightt">
                                                <tr>

                                                    <th scope="col"><Trans>requirments.common.passportType</Trans></th>
                                                    <th scope="col"><Trans>requirments.common.price</Trans></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><Trans>Page Run out</Trans></td>
                                                    <td>     5000 Birr                 </td>
                                                </tr>
    
                                            </tbody>
                                        </table>
                             
                                        <li><Trans>requirments.common.itemFour</Trans></li>
                                        <li><Trans>requirments.common.itemFive</Trans></li>
                                        <li><Trans>requirments.common.itemSix</Trans></li>
                                        <li><Trans>requirments.common.itemSeven</Trans></li>
                                        <ul class='my-1'>
                                            <li><Trans>requirments.common.itemSeven1</Trans></li>
                                            <li><Trans>requirments.common.itemSeven2</Trans></li>
                                            <li><Trans>requirments.common.itemSeven3</Trans></li>
                                        </ul>
                                    </ol>
                                </Typography>

                            </AccordionDetails>
                            <div class="col-12 medium text-center my-3"><Link to="/request-appointment" class="btn btnBlu"><Trans>requirments.common.applynow</Trans></Link></div>
                        </Accordion>
                        <Accordion className='accordion-item'>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel4a-content"
                                id="panel4a-header"
                            >
                                <Typography className='accordion-title'>
                                <Trans>howToApply.damagedPassport</Trans>
          </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    <p class='font-weight-bold'>
                                    <Trans>requirments.damagedPassport.title</Trans>  
                                    </p>

                                    <br></br>
                                    <ol>
                                        <li> <Trans>requirments.common.itemOne</Trans>  </li>
                                        <ul class='my-1'>
                                            <li><Trans>requirments.damagedPassport.itemOneL1</Trans> </li>

                                        </ul>

                                        <li><Trans>Check the service fee for the damaged Passport</Trans> </li>

                                        <table class="table w-75 my-1">
                                            <thead class="thead-lightt">
                                                <tr>
                                                    <th scope="col"><Trans>requirments.common.passportStatus</Trans> </th>
                                                    <th scope="col"><Trans>requirments.common.price</Trans> </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>   <Trans>Expired and Damage</Trans>   </td>
                                                    <td>13000 Birr</td>
                                                </tr>
           
                                                <tr>
                                                    <td>   <Trans>Valid and Damage</Trans>   </td>
                                                    <td>13000 Birr</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <li><Trans>requirments.common.itemFour</Trans></li>
                                        <li><Trans>requirments.common.itemFive</Trans></li>
                                        <li><Trans>requirments.common.itemSix</Trans></li>
                                        <li><Trans>requirments.common.itemSeven</Trans></li>
                                        <ul class='my-1'>
                                            <li><Trans>requirments.common.itemSeven1</Trans></li>
                                            <li><Trans>requirments.common.itemSeven2</Trans></li>
                                            <li><Trans>requirments.common.itemSeven3</Trans></li>
                                        </ul>
                                    </ol>

                                </Typography>


                            </AccordionDetails>
                            <div class="col-12 medium text-center my-3"><Link to="/request-appointment" class="btn btnBlu"><Trans>requirments.common.applynow</Trans></Link></div>
                        </Accordion>
                        <Accordion className='accordion-item'>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography className='accordion-title'>
                                <Trans>howToApply.lostPassport</Trans>
      </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    <p class='font-weight-bold'>
                                    <Trans>requirments.lostPassport.title</Trans>  
                                </p>

                                    <br></br>
                                    <ol>
                                        <li><Trans>requirments.common.itemOne</Trans>  </li>
                                        <ul class='my-1'>
                                            <li><Trans>requirments.lostPassport.itemOneL1</Trans>  </li>
                                            <li><Trans>requirments.lostPassport.itemOneL2</Trans>  </li>
                                            <li><Trans>requirments.lostPassport.itemOneL3</Trans>  </li>


                                        </ul>
                                        <li><Trans>Check the service fee for the Lost/Stolen Passport</Trans> </li>
                                        <table class="table w-75 my-1">
                                            <thead class="thead-lightt">
                                                <tr>
                                                    <th scope="col"><Trans>requirments.common.passportStatus</Trans> </th>
                                                    <th scope="col"><Trans>requirments.common.price</Trans> </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>   <Trans>Lost Passport</Trans>   </td>
                                                    <td>13000 Birr</td>
                                                </tr>
           
                                                <tr>
                                                    <td>   <Trans>Lost with Correction</Trans>   </td>
                                                    <td>20500 Birr</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <li><Trans>requirments.common.itemFour</Trans></li>
                                        <li><Trans>requirments.common.itemFive</Trans></li>
                                        <li><Trans>requirments.common.itemSix</Trans></li>
                                        <li><Trans>requirments.common.itemSeven</Trans></li>
                                        <ul class='my-1'>
                                            <li><Trans>requirments.common.itemSeven1</Trans></li>
                                            <li><Trans>requirments.common.itemSeven2</Trans></li>
                                            <li><Trans>requirments.common.itemSeven3</Trans></li>
                                        </ul>
                                    </ol>

                                </Typography>

                            </AccordionDetails>
                            <div class="col-12 medium text-center my-3"><Link to="/request-appointment" class="btn btnBlu"><Trans>requirments.common.applynow</Trans></Link></div>

                        </Accordion>
                        <Accordion className='accordion-item'>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3a-content"
                                id="panel3a-header"
                            >
                                <Typography className='accordion-title'>
                                <Trans>howToApply.changeofPassportData</Trans>
      </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>

                                    <p class='font-weight-bold'>
                                    <Trans>requirments.changeofPassportData.title</Trans>  

                                </p>

                                    <br></br>
                                    <ol>
                                        <li>    <Trans>requirments.common.itemOne</Trans>  </li>
                                        <ul class='my-1'>
                                            <li>        <Trans>requirments.changeofPassportData.itemOneL1</Trans>   </li>
                                            <li>        <Trans>requirments.changeofPassportData.itemOneL2</Trans>  </li>

                                        </ul>
                                        <li>    <Trans>Check the service fee for change of Passport data</Trans></li>

                                        <table class="table  my-1">
                                            <thead class="thead-lightt">
                                                <tr>
                                                <th scope="col"><Trans>requirments.common.passportStatus</Trans> </th>
                                                    <th scope="col"><Trans>requirments.common.price</Trans></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td ><Trans>Correction</Trans></td>
                                                    <td>      	12500 Birr</td>
                                                </tr>
                                        
                                                {/* <tr>
                                                    <td colspan="2" class='font-weight-bold'><Trans>requirments.common.forUrgent</Trans></td>

                                                </tr> */}
                                            </tbody>
                                        </table>
                                        <li><Trans>requirments.common.itemFour</Trans></li>
                                        <li><Trans>requirments.common.itemFive</Trans></li>
                                        <li><Trans>requirments.common.itemSix</Trans></li>
                                        <li><Trans>requirments.common.itemSeven</Trans></li>
                                        <ul class='my-1'>
                                            <li><Trans>requirments.common.itemSeven1</Trans></li>
                                            <li><Trans>requirments.common.itemSeven2</Trans></li>
                                            <li><Trans>requirments.common.itemSeven3</Trans></li>
                                        </ul>
                                    </ol>

                                </Typography>
                            </AccordionDetails>
                            <div class="col-12 medium text-center my-3"><Link to="/request-appointment" class="btn btnBlu"><Trans>requirments.common.applynow</Trans></Link></div>
                        </Accordion>
                        <Accordion className='accordion-item'>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3a-content"
                                id="panel3a-header"
                            >
                                <Typography className='accordion-title'>
                              <Trans>howToApply.validPassport</Trans>
      </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    <p class='font-weight-bold'>
                                    <Trans>Applicants for change of passport data with a valid passport must fulfill the following requirements. </Trans>  
                                </p>

                                    <br></br>
                                    <ol>
                                        <li> <Trans>requirments.common.itemOne</Trans> </li>
                                        <ul class='my-1'>
                                            <li>  <Trans>requirments.validPassport.itemOneL1</Trans>  </li>
                                        </ul>

                                        <li><Trans>Check the service fee for the new Passport</Trans></li>

                                        <table class="table  my-1">
                                            <thead class="thead-lightt">
                                                <tr>
                                                    <th scope="col"><Trans>requirments.common.passportStatus</Trans> </th>
                                                    <th scope="col"><Trans>requirments.common.price</Trans></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td ><Trans>Not expired/ valid passport</Trans> </td>
                                                    <td>13000 Birr	</td>
                                                </tr>
                                                <tr>
                                                    <td ><Trans>Valid passport with correction</Trans> </td>
                                                    <td>20500  Birr	</td>
                                                </tr>


                                                {/* <tr>
                                                    <td colspan="2" class='font-weight-bold'><Trans>requirments.common.forUrgent</Trans></td>

                                                </tr> */}
                                            </tbody>
                                        </table>
                                        <li><Trans>requirments.common.itemFour</Trans></li>
                                        <li><Trans>requirments.common.itemFive</Trans></li>
                                        <li><Trans>requirments.common.itemSix</Trans></li>
                                        <li><Trans>requirments.common.itemSeven</Trans></li>
                                        <ul class='my-1'>
                                            <li><Trans>requirments.common.itemSeven1</Trans></li>
                                            <li><Trans>requirments.common.itemSeven2</Trans></li>
                                            <li><Trans>requirments.common.itemSeven3</Trans></li>
                                        </ul>
                                    </ol>

                                </Typography>

                            </AccordionDetails>
                            <div class="col-12 medium text-center my-3"><Link to="/request-appointment" class="btn btnBlu"><Trans>requirments.common.applynow</Trans></Link></div>

                        </Accordion>
                        <Accordion className='accordion-item'>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3a-content"
                                id="panel3a-header"
                            >
                                <Typography className='accordion-title'>
                                <Trans>howToApply.applicantUnder18</Trans>
      </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>

                                    <p class='font-weight-bold'>
                                    <Trans>requirments.applicantUnder18.title</Trans>                                  </p>

                                    <br></br>
                                    <ol>
                                        <li> <Trans>requirments.common.itemOne</Trans>      </li>
                                        <ul class='my-1'>
                                            <li><Trans>requirments.applicantUnder18.itemOneL1</Trans>     </li>
                                            <li><Trans>requirments.applicantUnder18.itemOneL2</Trans>     </li>
                                            <li><Trans>requirments.applicantUnder18.itemOneL3</Trans>     </li>
                                        </ul>

                                    </ol>

                                </Typography>

                            </AccordionDetails>
                            <div class="col-12 medium text-center my-3"><Link to="/request-appointment" class="btn btnBlu"><Trans>requirments.common.applynow</Trans> </Link></div>

                        </Accordion>
                    
                    </div>
                </div>
            </div>



        </MDBContainer>
    );
}
